import { useEffect, useState } from "react";
import { apigetallHomeTestseries } from "../../services/apihomeTestseries/apihometestseries";
import { Link } from "react-router-dom";

const toUrlFriendly = (str) => {
  return str?.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
};

export default function HomeTestseries() {
  const [testData, setTestData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apigetallHomeTestseries({})
      .then((res) => {
        if (res?.resdata) setTestData(res.resdata);
      })
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  const isFree = (item) => {
    return parseInt(item.Price) === 0 && parseInt(item.Sale_Price) === 0;
  };

  if (loading) return <div className="py-10 text-center">Loading...</div>;
  if (testData.length === 0)
    return (
      <div className="py-10 text-center">
        <p>No Test Series Available</p>
      </div>
    );

  return (
    <section className="py-10 bg-gray-50">
      <div className="max-w-[75rem] mx-auto px-4">
        <div className="mb-5">
          <h2 className="text-2xl font-bold text-gray-800">Popular Test Series</h2>
        </div>
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {testData.map((item) => (
            <div
              key={item._id}
              className="overflow-hidden transition-shadow duration-300 bg-white shadow-[0px_0px_29px_0px_rgba(0,_0,_0,_0.1)] rounded-xl hover:shadow-[0px_0px_40px_0px_rgba(0,_0,_0,_0.15)]"
            >
              <div className="p-6">
                <h3 className="mb-2 text-xl font-bold text-gray-800">
                  {item.Test_name || ""}
                </h3>

                {isFree(item) ? (
                  <div className="py-4 mt-4">
                    <div className="text-center">
                      <span className="inline-block px-6 py-2 text-2xl font-bold text-green-600 bg-green-100 rounded-full">
                        FREE
                      </span>
                      <p className="mt-3 text-sm text-gray-600">
                        Access this test series at no cost
                      </p>
                    </div>
                  </div>
                ) : (
                  <div className="mt-4 space-y-3">
                    <div className="flex items-center justify-between">
                      <span className="text-sm text-gray-600">Original Price</span>
                      <span className="text-lg font-medium text-gray-500 line-through">
                        ₹{item.Price}
                      </span>
                    </div>

                    <div className="flex items-center justify-between">
                      <span className="text-sm text-gray-600">Discount</span>
                      <span className="px-2 py-1 text-xs font-semibold text-red-600 bg-red-100 rounded-full">
                        {item.Discount}% OFF
                      </span>
                    </div>

                    <div className="flex items-center justify-between pt-3 border-t">
                      <span className="text-sm font-semibold text-gray-700">Sale Price</span>
                      <span className="text-2xl font-bold text-green-600">
                        ₹{item.Sale_Price}
                      </span>
                    </div>
                  </div>
                )}

                <Link to={`/online-test-series/${toUrlFriendly(item.Test_name)}`}>
                  <button className="mt-6 w-full bg-regal-blue hover:bg-gradient-to-l hover:from-regal-yellow hover:to-regal-blue text-white font-medium py-2.5 rounded-lg transition-all duration-200">
                    {isFree(item) ? 'Start Free' : 'View Now'}
                  </button>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}